import { render, staticRenderFns } from "./global-search.vue?vue&type=template&id=56955564&scoped=true"
import script from "./global-search.vue?vue&type=script&lang=ts"
export * from "./global-search.vue?vue&type=script&lang=ts"
import style0 from "./global-search.vue?vue&type=style&index=0&id=56955564&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56955564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56955564')) {
      api.createRecord('56955564', component.options)
    } else {
      api.reload('56955564', component.options)
    }
    module.hot.accept("./global-search.vue?vue&type=template&id=56955564&scoped=true", function () {
      api.rerender('56955564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/_components/global-search.vue"
export default component.exports